import UserApi from "@/services/UserApi";

const state = {
	status: '',
	user: null,
  paymentSuccess: false,
  isAdmin: false,
}

const getters = {
  isLoggedIn: state => !!state.user,
  isAdmin: state => state.isAdmin,
	getUser: state => state.user,
	getToken: state => state.token,
	getPaymentSuccess: state => !!state.paymentSuccess
}

const actions = {
	SET_PAYMENTSUCCESS({commit}, paymentSuccess) {
		commit('setPaymentSuccess', paymentSuccess)
	},
	logout({commit}) {
		return UserApi.getLogout().then(user => {
			commit('logout')
		})
	},
	retrieveProfile({commit}) {
		if(state.user === null) {
			return UserApi.getProfile().then(user => {
				commit('retrieveProfile', user)
			})
		}
	}
}

const mutations = {
	setPaymentSuccess(state, paymentSuccess) {
		state.paymentSuccess = paymentSuccess
	},
	logout(state) {
    	state.user = null
  	},
  	retrieveProfile(state, user) {
      state.user = user
      state.isAdmin = user.is_admin;
  	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js